import moment from 'moment';
import { showAlert } from './util_helpers';

// region Function - Get Card Number Format String
export function getCardNumberFormat(cardBrand = '', last4Digits = '') {
    return(((cardBrand === 'diners' ? '•••• •••• ••' : (cardBrand === 'amex' ? '•••• •••••• •' : '•••• •••• •••• '))) + last4Digits);
}
// endregion

// region Function - Get Card Brand Image
export function getCardImage(cardBrand) {
    switch(cardBrand) {
        case 'amex': return(require('../images/cards/AmericanExpress.png'));
        case 'mastercard': return(require('../images/cards/MasterCard.png'));
        case 'visa': return(require('../images/cards/Visa.png'));
        case 'discover': return(require('../images/cards/Discover.png'));
        case 'diners': return(require('../images/cards/Discover.png'));
        case 'jcb': return(require('../images/cards/JCB.png'));
        case 'unionpay': return(require('../images/cards/Union-pay.png'));
        default: return(require('../images/cards/other.png'));
    }
}
// endregion

// region Function - Check if card is expiring
export function getCardValidity(expireMonth = 1, expireYear = 2020) {
    // 1: Warning (About to expire)
    // 2: Error (Expired)
    // 0: Normal
    return(
        expireYear === moment().year() ?
            (
                expireMonth === (moment().month() + 1) ?
                    1
                    :
                    (
                        (moment().month() > expireMonth) ?
                            2
                            :
                            (
                                ((moment().month() - expireMonth) === 0) ?
                                    1
                                    :
                                    0
                            )
                    )
            )
            :
            (
                moment().year() > expireYear ?
                    2
                    :
                    0
            )
    );
}
// endregion

// region Function - On Stripe Info Pressed
export function showStripeInfo() {
    showAlert({
        text: 'Your card information, alongside with all transaction data will be securely processed and saved by Stripe, Truckster does not store any of this information on its server',
        cancelButton: { text: 'Got it' },
        confirmButton: { text: 'Learn More', onPress: () => window.open('https://stripe.com/payments', '_blank') }
    });
}
// endregion
